<template>
    <div class="container">
        <header>
            <div class="banner">
                <van-row>
                    <van-col span="6" @click="back"><img class="back-icon"
                                                         :src="require(`@/assets/theme/${theme}/status/01dailyActive/01back.svg`)">
                    </van-col>
                    <van-col span="12">
                        <div class="banner-title">{{ $t('problemList.title') }}</div>
                    </van-col>
                </van-row>
            </div>
        </header>
        <div class="type-box" v-if="type=='ta806'">
            <div class="type-item" @click="toDesc('TA806')">
                <div class="type-icon">
                    <img class="type-img" src="@/assets/common/problem/TA806.png">
                </div>
                <div class="type-name">{{ $t('problemList.title') }}</div>
                <div class="type-model">{{ $t('problemList.model') }}: TA806-S、TA806-P、TA806-D</div>
                <img class="to-desc-img" src="@/assets/share/friendDesc/toAll.png">
            </div>
            <div class="problem-title">{{ $t('problemList.all') }}</div>
            <div class="problem-box">
                <div class="problem-item" @click="toArticle(13)">
                    {{ $t('problemList.zhibeizhen') }}
                    <img class="to-prob-img" src="@/assets/share/friendDesc/toAll.png">
                </div>
                <div class="problem-item" @click="toArticle(15)">
                    {{ $t('problemList.haiba') }}
                    <img class="to-prob-img" src="@/assets/share/friendDesc/toAll.png">
                </div>
                <div class="problem-item" @click="toAndroidMessage">
                    {{ $t('problemList.android') }}
                    <img class="to-prob-img" src="@/assets/share/friendDesc/toAll.png">
                </div>
                <div class="problem-item" @click="toIosMessage">
                    {{ $t('problemList.ios') }}
                    <img class="to-prob-img" src="@/assets/share/friendDesc/toAll.png">
                </div>
                <div class="problem-item" @click="toKeepAlive">
                    {{ $t('problemList.keepAlive') }}
                    <img class="to-prob-img" src="@/assets/share/friendDesc/toAll.png">
                </div>
                <div class="problem-item  last-item" @click="toSamSet">
                    {{ $t('problemList.prompt') }}
                    <img class="to-prob-img" src="@/assets/share/friendDesc/toAll.png">
                </div>
            </div>
        </div>
        <div class="type-box" v-if="type=='ta900'">
            <div class="type-item" @click="toDesc('TA900')">
                <div class="type-icon">
                    <img class="type-img" src="@/assets/common/problem/TA900.png">
                </div>
                <div class="type-name">{{ $t('problemList.instructions') }}</div>
                <div class="type-model">{{ $t('problemList.model') }}: TA906_S、TA900_P、TA900_D</div>
                <img class="to-desc-img" src="@/assets/share/friendDesc/toAll.png">
            </div>
            <div class="problem-title">{{ $t('problemList.all') }}</div>
            <div class="problem-box">
                <div class="problem-item" @click="toArticle(13)">
                    {{ $t('problemList.zhibeizhen') }}
                    <img class="to-prob-img" src="@/assets/share/friendDesc/toAll.png">
                </div>
                <div class="problem-item" @click="toArticle(14)">
                    {{ $t('problemList.sleep') }}
                    <img class="to-prob-img" src="@/assets/share/friendDesc/toAll.png">
                </div>
                <div class="problem-item" @click="toArticle(15)">
                    {{ $t('problemList.haiba') }}
                    <img class="to-prob-img" src="@/assets/share/friendDesc/toAll.png">
                </div>
                <div class="problem-item" @click="toArticle(5)">
                    {{ $t('problemList.map') }}
                    <img class="to-prob-img" src="@/assets/share/friendDesc/toAll.png">
                </div>
                <div class="problem-item" @click="toAndroidMessage">
                    {{ $t('problemList.android') }}
                    <img class="to-prob-img" src="@/assets/share/friendDesc/toAll.png">
                </div>
                <div class="problem-item" @click="toIosMessage">
                    {{ $t('problemList.ios') }}
                    <img class="to-prob-img" src="@/assets/share/friendDesc/toAll.png">
                </div>
                <div class="problem-item" @click="toKeepAlive">
                    {{ $t('problemList.keepAlive') }}
                    <img class="to-prob-img" src="@/assets/share/friendDesc/toAll.png">
                </div>
                <div class="problem-item  last-item" @click="toSamSet">
                    {{ $t('problemList.prompt') }}
                    <img class="to-prob-img" src="@/assets/share/friendDesc/toAll.png">
                </div>
            </div>
        </div>
        <div class="type-box" v-if="type=='ta600'">
            <div class="type-item" @click="toDesc('TA600')">
                <div class="type-icon">
                    <img class="type-img" src="@/assets/common/problem/TA600.png">
                </div>
                <div class="type-name">{{ $t('problemList.instructions') }}</div>
                <div class="type-model">{{ $t('problemList.model') }}: TA600</div>
                <img class="to-desc-img" src="@/assets/share/friendDesc/toAll.png">
            </div>
            <div class="problem-title">{{ $t('problemList.all') }}</div>
            <div class="problem-box">
                <div class="problem-item" @click="toArticle(13)">
                    {{ $t('problemList.zhibeizhen') }}
                    <img class="to-prob-img" src="@/assets/share/friendDesc/toAll.png">
                </div>
                <div class="problem-item" @click="toArticle(14)">
                    {{ $t('problemList.sleep') }}
                    <img class="to-prob-img" src="@/assets/share/friendDesc/toAll.png">
                </div>
                <div class="problem-item " @click="toArticle(15)">
                    {{ $t('problemList.haiba') }}
                    <img class="to-prob-img" src="@/assets/share/friendDesc/toAll.png">
                </div>
                <div class="problem-item" @click="toArticle(16)">
                    {{ $t('problemList.ecg') }}
                    <img class="to-prob-img" src="@/assets/share/friendDesc/toAll.png">
                </div>
                <div class="problem-item" @click="toAndroidMessage">
                    {{ $t('problemList.android') }}
                    <img class="to-prob-img" src="@/assets/share/friendDesc/toAll.png">
                </div>
                <div class="problem-item" @click="toIosMessage">
                    {{ $t('problemList.ios') }}
                    <img class="to-prob-img" src="@/assets/share/friendDesc/toAll.png">
                </div>
                <div class="problem-item" @click="toKeepAlive">
                    {{ $t('problemList.keepAlive') }}
                    <img class="to-prob-img" src="@/assets/share/friendDesc/toAll.png">
                </div>
                <div class="problem-item  last-item" @click="toSamSet">
                    {{ $t('problemList.prompt') }}
                    <img class="to-prob-img" src="@/assets/share/friendDesc/toAll.png">
                </div>
            </div>
        </div>
        <div class="type-box" v-if="type=='ta2000'">
            <div class="type-item" @click="toDesc('TA2000')">
                <div class="type-icon">
                    <img class="type-img" src="@/assets/common/problem/TA2000.png">
                </div>
                <div class="type-name">{{ $t('problemList.instructions') }}</div>
                <div class="type-model">{{ $t('problemList.model') }}: TA2000</div>
                <img class="to-desc-img" src="@/assets/share/friendDesc/toAll.png">
            </div>
            <div class="problem-title">{{ $t('problemList.all') }}</div>
            <div class="problem-box">
                <div class="problem-item" @click="toArticle(13)">
                    {{ $t('problemList.zhibeizhen') }}
                    <img class="to-prob-img" src="@/assets/share/friendDesc/toAll.png">
                </div>
                <div class="problem-item" @click="toArticle(14)">
                    {{ $t('problemList.sleep') }}
                    <img class="to-prob-img" src="@/assets/share/friendDesc/toAll.png">
                </div>
                <div class="problem-item " @click="toArticle(15)">
                    {{ $t('problemList.haiba') }}
                    <img class="to-prob-img" src="@/assets/share/friendDesc/toAll.png">
                </div>
                <div class="problem-item" @click="toArticle(16)">
                    {{ $t('problemList.ecg') }}
                    <img class="to-prob-img" src="@/assets/share/friendDesc/toAll.png">
                </div>
                <div class="problem-item" @click="toAndroidMessage">
                    {{ $t('problemList.android') }}
                    <img class="to-prob-img" src="@/assets/share/friendDesc/toAll.png">
                </div>
                <div class="problem-item" @click="toIosMessage">
                    {{ $t('problemList.ios') }}
                    <img class="to-prob-img" src="@/assets/share/friendDesc/toAll.png">
                </div>
                <div class="problem-item" @click="toKeepAlive">
                    {{ $t('problemList.keepAlive') }}
                    <img class="to-prob-img" src="@/assets/share/friendDesc/toAll.png">
                </div>
                <div class="problem-item" @click="toSamSet">
                    {{ $t('problemList.prompt') }}
                    <img class="to-prob-img" src="@/assets/share/friendDesc/toAll.png">
                </div>
                <div class="problem-item last-item" @click="toMap(13)">
                    {{ $t('problemList.map') }}
                    <img class="to-prob-img" src="@/assets/share/friendDesc/toAll.png">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {getQueryVariable} from '@/utils/comment'
    export default {
        name: 'problemList',
        data() {
            return {
                type: getQueryVariable('type'),
                from: getQueryVariable('from') ? getQueryVariable('from') : "",
                theme: getQueryVariable("theme") ? getQueryVariable("theme") : "light",
                maxKbScript: null
            }
        },
        mounted() {
            // this.loadMaxKbScript();
        },
        beforeDestroy() {
            // this.removeMaxKbScript();
        },
        methods: {
            back() {
                if (this.from == 'web') {
                    this.$router.back()
                } else {
                    WebJSBridge.call("closeWeb", null, function (res) {
                    });
                }
            },
            toDesc(type){
                if (type == 'TA806') {
                    window.location.href='https://service.beidouwatch.com/bdwatch_web/view/comProblem.html';
                } else {
                    window.location.href='https://service.beidouwatch.com/bdwatch_web/view/'+ type +'Instructions.html';
                }
            },
            toArticle(id) {
                let lang = this.$i18n.locale;
                if (lang == 'en') {
                    if (id == 13) {
                        id = 25
                    } else if (id == 14) {
                        id = 26
                    } else if (id == 15) {
                        id = 27
                    } else if (id == 16) {
                        id = 28
                    }
                } else if (lang == 'ja') {
                    if (id == 13) {
                        id = 68
                    } else if (id == 14) {
                        id = 69
                    } else if (id == 15) {
                        id = 70
                    } else if (id == 16) {
                        id = 71
                    }
                }
                window.location.href='https://service.beidouwatch.com/bdwatch_web/view/article.html?id=' + id;
            },
            toAndroidMessage() {
                this.$router.push({
                    name: 'androidMessageSet',
                    query: {
                        lang: this.$i18n.locale
                    }
                })
            },
            toIosMessage() {
                this.$router.push({
                    name: 'iosMessageSet'
                })
            },
            toSamSet() {
                this.$router.push({
                    name: 'samSet',
                    query: {
                        lang: this.$i18n.locale
                    }
                })
            },
            toKeepAlive() {
                this.$router.push({
                    name: 'keepAlive',
                    query: {
                        lang: this.$i18n.locale
                    }
                })
            },
            toMap() {
                this.$router.push({
                    name: 'ta2000desc'
                })
            },
            loadMaxKbScript() {
                console.log('loadMaxKbScript');
                let maxKb = document.getElementById('maxkb');
                if (maxKb) {
                    maxKb.style.display = 'block';
                }
                const script = document.createElement('script');
                script.async = true;
                script.defer = true;
                script.src = 'https://service.beidouwatch.com/api/application/embed?protocol=https&host=service.beidouwatch.com&token=3a8b66e71698bb52';
                document.body.appendChild(script);
                this.maxKbScript = script;
            },
            removeMaxKbScript() {
                console.log('removeMaxKbScript');
                if (this.maxKbScript && this.maxKbScript.parentNode) {
                    this.maxKbScript.parentNode.removeChild(this.maxKbScript);
                }
                let maxKb = document.getElementById('maxkb');
                if (maxKb) {
                    maxKb.style.display = 'none';
                }
            }
        }
    }
</script>

<style scoped>
    .type-item {
        width: 345px;
        height: 70px;
        background: var(--bg-color-2);
        opacity: 1;
        border-radius: 6px;
        margin: 20px auto 10px;
        position: relative;
    }

    .type-img {
        width: 50px;
        position: absolute;
        top: 10px;
        left: 15px;
    }

    .type-name {
        font-family: SemiBoldItalic;
        position: absolute;
        left: 70px;
        top: 15px;
        font-size: 15px;
        color: var(--text-color-1);
    }

    .type-model {
        position: absolute;
        left: 70px;
        top: 35px;
        font-size: 12px;
        color: var(--text-color-2);
    }

    .to-desc-img {
        position: absolute;
        right: 15px;
        top: 28px;
        width: 14px;
    }

    .problem-title {
        margin-left: 30px;
        font-size: 16px;
        color: var(--text-color-1);;
    }

    .problem-box {
        width: 345px;
        background: var(--bg-color-2);
        opacity: 1;
        border-radius: 6px;
        margin: 10px auto 10px;
        color: var(--text-color-1);
    }

    .problem-item {
        padding: 15px 0;
        width: 315px;
        margin: 0 auto;
        font-size: 14px;
        border-bottom: 1px solid var(--text-color-3);
        position: relative;
    }

    .last-item {
        border-bottom: none;
    }

    .to-prob-img {
        position: absolute;
        right: 0px;
        top: 17px;
        width: 14px;
    }
</style>



// WEBPACK FOOTER //
// src/views/common/problemList.vue